import { KYCStatus } from '../types'

export const KYC_REGISTRATION_COMPLETED_STATUS: KYCStatus[] = [
  'KYC_APPROVED',
  'KYC_PENDING_COMPANY_ID',
  'KYC_PENDING_VALIDATION',
  'KYC_PENDING_REVIEW_CREATION',
]
